<template>
  <div class="campaign-card-header">
    <div class="campaign-card-header__media-wrapper">
      <div class="media-wrapper__media" :style="background">
        <div class="campaign-status-label-wrapper">
          <CampaignCardHeaderStatusLabel
            :status="status"
            :remaining-days="remainingDays"
          />
        </div>
      </div>
    </div>
    <div class="campaign-card-header__user-area">
      <div class="user-area__overlay"></div>
      <BaseAvatarIcon
        class="user-area__user-icon"
        alt="user icon"
        :src="user['avatar_image']['file']"
      />
      <div class="user-area__user-name">{{ nickNameEllipsis }}</div>
    </div>
  </div>
</template>

<script>
import BaseAvatarIcon from '@/components/BaseAvatarIcon';
import CampaignCardHeaderStatusLabel from '@/components/CampaignCardHeaderStatusLabel';
import { ellipsis } from '@/format-helper';

export default {
  name: 'CampaignCardHeader',
  components: {
    BaseAvatarIcon,
    CampaignCardHeaderStatusLabel,
  },
  props: {
    status: {
      ...CampaignCardHeaderStatusLabel.props.status,
    },
    mainVisual: {
      type: String,
      required: true,
    },
    remainingDays: {
      ...CampaignCardHeaderStatusLabel.props.remainingDays,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    background() {
      return this.mainVisual
        ? `background: url('${this.mainVisual}') center center / cover no-repeat;`
        : '';
    },
    nickNameEllipsis() {
      return ellipsis(this.user['profile']['nickname'], 30);
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card-header {
  position: relative;
}

/**
 * CSS芸で幅:高さ = 3:2にする
 */
.campaign-card-header__media-wrapper {
  position: relative;
  width: 100%;

  &:before {
    content: '';
    display: block;
    padding-top: 66.666666666%;
  }
}

.media-wrapper__media {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  /*
   * v-card-mediaの仕様かどうかは不明だが、
   * 親のborder-radiusに従ってくれないので個別に指定する
   */
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.campaign-status-label-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

$height-of-overlay: 68px;
.campaign-card-header__user-area {
  position: absolute;
  width: 100%;
  height: #{$height-of-overlay};
  bottom: 0;
}

.user-area__overlay {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;

  width: 100%;
  height: #{$height-of-overlay};

  background: linear-gradient(
    180deg,
    rgba(49, 51, 51, 0) 0%,
    rgba(49, 51, 51, 0.7) 60.94%
  );
  border-radius: 4px 4px 0 0;
}

$user-icon-left: 12px;
.user-area__user-icon {
  position: absolute !important;
  left: #{$user-icon-left};
  bottom: 10px;
  z-index: 2;

  width: 48px;
  height: 48px;
  @include mq(sm-and-down) {
    width: 40px;
    height: 40px;
  }
}

.user-area__user-name {
  position: absolute;
  z-index: 2;

  left: calc(#{$user-icon-left} + 48px + 8px);
  top: 24px;
  @include mq(sm-and-down) {
    left: calc(#{$user-icon-left} + 40px + 8px);
    top: 25px;
  }

  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  color: $c-white-base;
}
</style>
